import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I am <span className="purple">Afreul Kaium Joy </span>
            from <span className="purple"> Dhaka,Bangladesh.</span>
            <br />
            I’m currently doing a BSc in Computer Science and Engineering.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Photography
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "#1C3879" }}>
            "Every man dies. Not every man really lives . <br />
             live the life of your DREAMS."{" "}
          </p>
          <footer className="blockquote-footer">My Philosophy</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
